<div class="acct" (clickOutside)="onClickedOutside()">
  <button
    #trigger
    id="acct-trigger"
    type="button"
    class="acct__trigger"
    aria-haspopup="menu"
    [attr.aria-expanded]="openOptions"
    [attr.aria-controls]="openOptions ? 'acct-menu' : null"
    [attr.aria-label]="userName ? 'Account menu, ' + userName : 'Account menu'"
    (click)="toggleOPenOptions()"
    (keydown)="onTriggerKeydown($event)"
  >
    <app-avatar [imageSrc]="profileImageUrl" [name]="userName" [size]="34" />
  </button>

  @if (openOptions) {
    <!-- A plain popover: only the list below is the menu, so the facts above stay readable.
         They are also the menu's description, heard when focus moves into it. -->
    <div #menu class="bk-menu is-right is-shown acct__menu" (keydown)="onMenuKeydown($event)">
      <!-- Who and where -->
      <div class="acct__head">
        <app-avatar [imageSrc]="profileImageUrl" [name]="userName" [size]="40" />
        <div class="acct__who" id="acct-who">
          <p class="acct__name">{{ userName || 'Your account' }}</p>
          @if (email) {
            <p class="acct__email" [attr.title]="email">{{ email }}</p>
          }
        </div>
      </div>

      <dl class="acct__meta" id="acct-meta">
        <div class="acct__fact">
          <dt>Organization</dt>
          <dd [attr.title]="orgName || null">{{ orgName || '—' }}</dd>
        </div>
        <div class="acct__fact">
          <dt>Role</dt>
          <dd [attr.title]="roleText || null">{{ roleText || '—' }}</dd>
        </div>
      </dl>

      <div class="bk-menu__sep" role="separator"></div>

      <div
        id="acct-menu"
        class="bk-menu__list"
        role="menu"
        aria-labelledby="acct-trigger"
        aria-describedby="acct-who acct-meta"
      >
        <a
          role="menuitem"
          tabindex="-1"
          class="bk-menu__item"
          routerLink="/organization/settings/profile"
          (click)="closeOptions()"
        >
          <span class="bk-sym" aria-hidden="true">person</span>
          Profile
        </a>
        @if (canSeeOrganization) {
          <a
            role="menuitem"
            tabindex="-1"
            class="bk-menu__item"
            routerLink="/organization/settings/organization"
            (click)="closeOptions()"
          >
            <span class="bk-sym" aria-hidden="true">domain</span>
            Organization settings
          </a>
        }

        <div class="bk-menu__sep" role="separator"></div>

        <button
          type="button"
          role="menuitem"
          tabindex="-1"
          class="bk-menu__item"
          data-tone="danger"
          (click)="openLogoutPrompt()"
        >
          <span class="bk-sym" aria-hidden="true">logout</span>
          Sign out
        </button>
      </div>
    </div>
  }
</div>

<app-prompt-card
  [openModal]="openLogout"
  title="Sign out of Black Konnect?"
  buttonText="Sign out"
  tone="danger"
  closeText="Stay signed in"
  (onClose)="closeLogoutPrompt()"
  (onButtonClick)="handleLogout()"
>
  <p class="acct__prompt">You will need your email address and password to sign back in.</p>
</app-prompt-card>
